import { colors } from '@airwallex/global';
import { getLuminance, transparentize, darken, lighten } from 'polished';
export var navThemeFromPartnerTheme = function navThemeFromPartnerTheme(partnerTheme) {
  try {
    var lightOnDark = getLuminance(partnerTheme.itemColor || '') > getLuminance(partnerTheme.backgroundColor || '');
    return {
      background: partnerTheme.backgroundColor || '',
      item: {
        color: partnerTheme.itemColor || '',
        hover: {
          color: (lightOnDark ? lighten : darken)(0.2, partnerTheme.itemColor || '')
        },
        selected: {
          color: partnerTheme.itemSelectedColor
        },
        tag: {
          background: partnerTheme.itemColor || '',
          color: partnerTheme.backgroundColor || '',
          selected: {
            background: partnerTheme.itemSelectedColor || '',
            color: partnerTheme.backgroundColor || ''
          }
        }
      },
      button: {
        hover: {
          background: transparentize(0.8, partnerTheme.itemColor || '')
        }
      },
      subMenuLine: transparentize(0.5, partnerTheme.itemColor || ''),
      tooltip: {
        background: colors.greys[70]
      },
      logoUrl: partnerTheme.logoUrl || undefined
    };
  } catch (e) {
    // log it for debugging
    console.error(e); // fall back to no custom theme

    return undefined;
  }
};